type ImagesMap = {
  [K in keyof RegisteredImages]: RegisteredImages[K];
};

const images = {} as ImagesMap;

export function registerImages<K extends keyof RegisteredImages>(
  namespace: K,
  newImages: RegisteredImages[K],
) {
  images[namespace] = {
    ...images[namespace],
    ...newImages,
  };
}

export function getImages() {
  return images;
}
